import * as loadingActionsType from "@/constants/loadingActionsType";

export function isShowRecoveryLoading(value) {
  return {
    type: loadingActionsType.SHOW_RECOVERY_LOADING,
    value,
  };
}

/**
 * @param {Boolean} value
 * @returns
 */
export function showLoading(value) {
  return {
    type: loadingActionsType.SHOW_LOADING,
    value,
  };
}

/**
 * @param {Object} value
 * @param {Boolean} value.showLoading
 * @param {String} value.loadingText
 * @param {Event} value.loadingClickEvent
 * @param {Object} value.loadingButton1
 * @param {String} value.loadingButton1.label
 * @param {Event} value.loadingButton1.onClick
 * @param {booleant} value.loadingButton1.disabled
 * @returns
 */
export function updateLoading(value) {
  return {
    type: loadingActionsType.UPDATE_LOADING,
    value,
  };
}

/**
 * @param {String} value
 * @returns
 */
export function updateLoadingText(value) {
  return {
    type: loadingActionsType.UPDATE_LOADING_TEXT,
    value,
  };
}
